module.exports = __webpack_public_path__ + "static/media/baseketball.4661cee5.svg";